import { render, staticRenderFns } from "./KoreanLiveCartNew.vue?vue&type=template&id=15885bb8&scoped=true"
import script from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
export * from "./KoreanLiveCartNew.vue?vue&type=script&lang=js"
import style0 from "./KoreanLiveCartNew.vue?vue&type=style&index=0&id=15885bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15885bb8",
  null
  
)

export default component.exports